// extracted by mini-css-extract-plugin
export default {"label":"label__rQdXe","input":"input__tb-hB"};